import { render, staticRenderFns } from "./MoveLobbyClosed.vue?vue&type=template&id=8a1f568a&"
import script from "./MoveLobbyClosed.vue?vue&type=script&lang=js&"
export * from "./MoveLobbyClosed.vue?vue&type=script&lang=js&"
import style0 from "./MoveLobbyClosed.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports